var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('filter-form-layout',[_vm._l((_vm.fields),function(ref){
var name = ref.name;
var control = ref.control;
return [(control)?_c('filter-form-control',_vm._b({key:Array.isArray(name) ? name.join('') : name,attrs:{"form":_vm.form,"field-name":name}},'filter-form-control',control,false)):_vm._e()]}),_vm._t("meta-filters"),_c('filter-form-clear-button',{attrs:{"slot":"clear-button","disabled":_vm.areFieldsClear},on:{"click":_vm.clear},slot:"clear-button"})],2)}
var staticRenderFns = []

export { render, staticRenderFns }